import type { ContactItem } from '~/types/contact'
import { CONTACT_TYPE } from '~/constants'

export const contactUs: ContactItem = {
  title: 'Live chat',
  label: '',
  link: '',
  type: CONTACT_TYPE.LIVECHAT,
  isNewTab: false,
  img: '/icons/icon-live-chat.svg',
}
